import ABCyaPhaser from "@abcya/abcya_phaser";
import FractionDisplay from "./FractionDisplay";

export default class FractionTile extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);

        this.workingWidth = 0;
        this.workingHeight = 0;
        this.bg = null;
        this.fractionDisplay = null;
        this.fractionValue = null;
        this.selected = false;
        this.isUsed = false;
        this.active = true;

        this.bg = ABCyaPhaser.Images.addImage(0, 0, "SquareBg", this);
        this.workingWidth = this.bg.width;
        this.workingHeight = this.bg.height;

        this.fractionDisplay = new FractionDisplay(this.scene);
        this.add(this.fractionDisplay);
    }

    centerContainer()
    {
        let bounds = this.getBounds();
        // this centers the objects in the container, used as a replacement for changing the origin/pivot in Createjs (which isn't possible in Phaser)
        this.iterate(child =>
        {
            child.x -= bounds.width / 2;
            child.y -= bounds.height / 2;
        });
    }

    setValue(fraction)
    {
        this.fractionValue = fraction;
        this.fractionDisplay.reset(fraction);
        this.fractionDisplay.x = Math.floor(this.workingWidth / 2 - this.fractionDisplay.workingWidth / 2);
        this.fractionDisplay.y = Math.floor(this.workingHeight / 2 - this.fractionDisplay.workingHeight / 2);
    }

    select()
    {
        this.selected = true;
        this.bg.setFrame("SquareBg_selected");
    }

    unselect()
    {
        this.selected = false;
        this.bg.setFrame("SquareBg");
    }

    showCorrect(isCorrect)
    {
        let c = 0;
        this.isUsed = isCorrect;
        if (isCorrect === true)
        {
            this.bg.setFrame("SquareBg_correct");
            c = 0x00a651;
        }
        else
        {
            this.bg.setFrame("SquareBg_incorrect");
            c = 0xed1c24;
        }
        this.fractionDisplay.colorFraction(c);
    }

    discardTile()
    {
        this.active = false;
        this.bg.setFrame("SquareBg");
        this.bg.alpha = 0.5;
        this.fractionDisplay.setVisible(false);
    }

    getGlobalFractionLoc()
    {
        let pt = ABCyaPhaser.GameObjects.getScreenPosition(this.fractionDisplay);
        return pt;
    }

    resetDisplay ()
    {
        this.bg.setFrame("SquareBg");
        this.fractionDisplay.colorFraction(null);
        this.selected = false;
    }

    hideFraction ()
    {
        this.fractionDisplay.setVisible(false);
    }
}